import React from "react";
import { convertToDateMonthFormat } from "../../utils/ConvertDate";

export const exportExcel = async (data: any) => {
  import("xlsx-js-style").then((xlsx) => {
    const parseData = data.map((item: any) => {
      return {

        "Threat Sources": item.threatSourceName || "", 
        "Threat Event(s)": (item.threatEvents || [])
          .map((th: { threatEventName: any }) => th.threatEventName || "")

          .join(","),
        "Potential Vulnerabilities": (item.vulnerabilites || [])
          .map((vu: { vulnerabiliteName: any }) => vu.vulnerabiliteName || "")
          .join(","),
        Likelihood: item.likelihoodName || "", 
        "Adverse Impact": item.adverseImpactName || "", 
        "Inhrent Risk": item.inherentRiskName || "", 
        "Control(s)": (item.controls || [])
          .map((c: { controlsName: any }) => c.controlsName || "")
          .join(","),
        "Residual Risk": item.residualRiskName || "", 
        "Risk Response": item.responseName || "", 
        Comments: item.comment || "",
      };
    });

    const worksheet = xlsx.utils.json_to_sheet(parseData);
    Object.keys(worksheet).forEach((i) => {
      const cell = xlsx.utils.decode_cell(i);
      if (cell.c > 2 && cell.c < 6) {
        let color = "ffffff";
        if (worksheet[i].v === "High") color = "c00000";
        else if (worksheet[i].v === "Medium") color = "ffff00";
        else if (worksheet[i].v === "Low") color = "00b050";
        worksheet[i].s = {
          fill: {
            patternType: "solid",
            fgColor: { rgb: color },
            bgColor: { rgb: color },
          },
        };
      }
    });

    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Cybersecurity");

    worksheet["!cols"] = Object.keys(parseData[0]).map((ele) => ({
      wch: 25,
    }));

    xlsx.writeFile(workbook, "Risk Assessment Cybersecurity.xlsx", {
      compression: true,
    });
  });
};


//Download spreadsheet for Supply chain
export const exportExcelSupplyChain = async (data: any) => {
  import("xlsx-js-style").then((xlsx) => {
    const parseData = data.map((item: any) => {
      return {
        "Supplier Name": item.supplierName,
        "Supplier Product": item.supplierProduct,
        "Supplier Service": item.supplierService,
        "Does the organization rely on the listed product or service for critical processes?":
          item.criticalProcessesDependency,
        "Does the supplier store, transmit, or access confidential organization or customer data?":
          item.confidentialDataAccess,
        "Supplier Risk Level:": item.supplierRiskLevel,
      };
    });

    const worksheet = xlsx.utils.json_to_sheet(parseData);
    Object.keys(worksheet).forEach((i) => {
      const cell = xlsx.utils.decode_cell(i);
      if (cell.c > 2 && cell.c < 6) {
        let color = "ffffff";
        if (worksheet[i].v === "Critical" || worksheet[i].v === "Yes")
          color = "c00000";
        else if (worksheet[i].v === "Non-Critical" || worksheet[i].v === "No")
          color = "00b050";
        worksheet[i].s = {
          fill: {
            patternType: "solid",
            fgColor: { rgb: color },
            bgColor: { rgb: color },
          },
        };
      }
    });

    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Cybersecurity");

    /* calculate column width */
    worksheet["!cols"] = Object.keys(parseData[0]).map((ele) => ({
      wch: 25,
    }));

    xlsx.writeFile(workbook, "Risk Assessment Supply Chain.xlsx", {
      compression: true,
    });
  });
};

//Get Inherent Risk val
export const getInherentRisk = (
  formValues: any,
  likehoodList: any[],
  adverseImpactList: any[]
) => {
  let inherentRiskName = "";
  const riskMap = {
    High: {
      High: "High",
      Medium: "High",
      Low: "Medium",
    },
    Medium: {
      High: "High",
      Medium: "Medium",
      Low: "Low",
    },
    Low: {
      High: "Medium",
      Medium: "Low",
      Low: "Low",
    },
  };

  const likelihood = likehoodList.find(
    (item) => item.likelihoodID === formValues.likelihood
  )?.likelihoodName;
  // console.log("getInherentRisk likelihood", likelihood);

  const adverseImpact = adverseImpactList.find(
    (item) => item.adverseImpactID === formValues.adverseImpact
  )?.adverseImpactName;
  // console.log("getInherentRisk adverseImpact", adverseImpact);

  if (likelihood && adverseImpact) {
    inherentRiskName = riskMap[likelihood]?.[adverseImpact] || "";
  }
  // console.log("getInherentRisk inherentRiskName", inherentRiskName);
  return inherentRiskName;
};

//Download spreadsheet for Threat source
export const exportExcelThreatSource = async (data: any) => {
  import("xlsx").then((xlsx) => {
    const parseData = data.map((item: any) => {
      return {
        Name: item.threatName,
      };
    });

    const worksheet = xlsx.utils.json_to_sheet(parseData);
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Cybersecurity");

    /* calculate column width */
    worksheet["!cols"] = Object.keys(parseData[0]).map((ele) => ({
      wch: 25,
    }));

    xlsx.writeFile(workbook, "Risk Assessment Threat Sources.xlsx", {
      compression: true,
    });
  });
};
